import { mapGetters } from "vuex";

export default {
  name: 'MattingTips',
  computed: {
    ...mapGetters(["UserMsg", "cutoutNum"])
  },
  methods: {
    judgeMatting () {
      // this.cutoutNum.rest = 0; // 测试数据
      // this.UserMsg.levelType = 4; // 测试数据
      // this.UserMsg.level = 1; // 测试数据
      if (this.cutoutNum.use <= 0) {
        this.$memberGuide({
          show: true,
          context: this,
          funcRight: {
            type: "AIMatting",
            name: "AI抠图",
          },
        });
        return false;
      }
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/judgeMatting.js